import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { Rocket, Award, ArrowUpRight, Phone, Sparkles } from 'lucide-react';

const STORAGE_KEY = 'pp_welcome_dismissed_v1';

const WelcomeModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Show once per browser (until user clears storage)
    let dismissed = false;
    try { dismissed = localStorage.getItem(STORAGE_KEY) === '1'; } catch (_) {}
    if (!dismissed) {
      const t = setTimeout(() => setOpen(true), 2000);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) dismiss(); }}>
      <DialogContent
        className="p-0 border-0 bg-transparent shadow-none max-w-[560px] w-[calc(100vw-32px)]"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="relative overflow-hidden rounded-[24px] bg-white border border-[#E7E8EC] shadow-[0_40px_80px_-20px_rgba(17,17,17,0.35)]">
          {/* Decorative gradient */}
          <div className="pointer-events-none absolute -top-24 -right-24 w-[360px] h-[360px] rounded-full bg-[#EFEBFE] blur-3xl opacity-80" />
          <div className="pointer-events-none absolute -bottom-32 -left-24 w-[360px] h-[360px] rounded-full bg-[#F3F0FE] blur-3xl opacity-70" />

          <div className="relative p-7 sm:p-9">
            {/* Top row: badge */}
            <div className="flex items-center gap-2 mb-5">
              <div className="inline-flex items-center gap-2 h-7 px-3 rounded-full bg-[#F1EEFE] text-[#6E56E7] text-[11px] font-semibold tracking-[0.16em] uppercase">
                <Rocket className="w-3.5 h-3.5" strokeWidth={2.4} />
                Website im Umbau
              </div>
              <div className="inline-flex items-center gap-1.5 h-7 px-3 rounded-full bg-[#111111] text-white text-[11px] font-semibold tracking-[0.14em] uppercase">
                <Award className="w-3.5 h-3.5" strokeWidth={2.4} />
                Seit 15+ Jahren
              </div>
            </div>

            <DialogTitle asChild>
              <h2 className="text-[26px] sm:text-[30px] leading-[1.1] font-black tracking-[-0.02em] text-[#111111]">
                Willkommen bei <span className="text-[#6E56E7]">PurePromo</span>.
              </h2>
            </DialogTitle>

            <DialogDescription asChild>
              <p className="mt-3 text-[14.5px] leading-relaxed text-slate-500">
                Unsere neue Website befindet sich aktuell im Umbau. Als Ihre Promotion- und Vertriebsagentur für Telekommunikation sind wir wie gewohnt für Sie da – telefonisch, per E-Mail oder direkt vor Ort. Schauen Sie sich schon jetzt einen kleinen Vorgeschmack an.
              </p>
            </DialogDescription>

            {/* Quick facts */}
            <div className="mt-6 grid grid-cols-3 gap-3">
              <div className="rounded-2xl bg-[#F6F7F9] border border-[#E7E8EC] px-3 py-3">
                <div className="text-[18px] font-black text-[#111111] tabular-nums">15+</div>
                <div className="text-[11px] text-slate-500 mt-0.5">Jahre Erfahrung</div>
              </div>
              <div className="rounded-2xl bg-[#F6F7F9] border border-[#E7E8EC] px-3 py-3">
                <div className="text-[18px] font-black text-[#111111]">7+</div>
                <div className="text-[11px] text-slate-500 mt-0.5">Partnermarken</div>
              </div>
              <div className="rounded-2xl bg-[#F6F7F9] border border-[#E7E8EC] px-3 py-3">
                <div className="text-[18px] font-black text-[#111111]">DE</div>
                <div className="text-[11px] text-slate-500 mt-0.5">bundesweit</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="mailto:info@purepromo.de"
                onClick={dismiss}
                className="pp-btn group inline-flex items-center gap-2 h-11 px-5 rounded-full bg-[#111111] text-white text-[13.5px] font-semibold hover:bg-black"
              >
                Kontakt aufnehmen
                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a
                href="tel:+4915153764622"
                onClick={dismiss}
                className="pp-btn inline-flex items-center gap-2 h-11 px-5 rounded-full bg-white text-[#111111] text-[13.5px] font-semibold border border-[#E7E8EC] hover:border-[#111111]"
              >
                <Phone className="w-4 h-4" />
                015153764622
              </a>
              <button
                type="button"
                onClick={dismiss}
                className="ml-auto inline-flex items-center gap-1.5 text-[13px] font-semibold text-slate-500 hover:text-[#111111] transition"
              >
                <Sparkles className="w-3.5 h-3.5" />
                Vorschau ansehen
              </button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
